import AuthStore from './Auth';
import GraphsStore from './Graphs';
import { ResidentDetailStore } from './Residents';
import PermissionsStore from './Permissions';
import { HealthcareProviderDetailStore } from './HealthcareProviders';
import NotificationsStore from './Ui/Notifications';
import ConfirmationStore from './Ui/Confirmation';
import PresenceStore from './Presence';

import { SiteSettingsStore } from './Settings';
import SitesStore from '~/modules/sites/store/Sites';
import DevicesStore from '~/modules/devices/store/Devices';
import DeviceStore from '~/modules/devices/store/Device';
import AlertsStore from './Alert/Alerts';

export class RootStore {
  auth: any;
  graphs: any;
  healthcareProviderDetail: any;
  siteSettings: any;
  sites: any;
  devices: DevicesStore;
  device: DeviceStore;
  permissions: any;
  residentDetail: any;
  alertDetail: any;
  confirmation: any;
  alerts: any;
  notifications: any;
  presence: PresenceStore;

  constructor(initialState = {}) {
    this.permissions = new PermissionsStore(this);
    this.auth = new AuthStore(this);
    this.graphs = new GraphsStore(this);
    this.healthcareProviderDetail = new HealthcareProviderDetailStore(this);
    // PresenceStore must exist before AlertsStore — the alert socket routes
    // self_presence_changed events into it.
    this.presence = new PresenceStore(this);
    this.alerts = new AlertsStore(this);
    this.siteSettings = new SiteSettingsStore(this);
    this.sites = new SitesStore(this);
    this.devices = new DevicesStore(this);
    this.device = new DeviceStore(this);
    this.residentDetail = new ResidentDetailStore(this);
    this.confirmation = new ConfirmationStore(this);
    this.notifications = new NotificationsStore(this);

    for (const key in initialState) {
      if (this[key] && typeof this[key].fromJSON === 'function') {
        this[key].fromJSON(initialState[key]);
      } else if (this[key]) {
        this[key] = initialState[key];
      }
    }
  }

  reset() {
    this.alerts.reset();
    this.sites.reset();
    this.devices.reset();
    this.device.reset();
    this.permissions.clear();
    this.presence.reset();
  }

  toJSON() {
    // Exclude rootStore from serialization for sub-stores
    const obj = {};
    for (const key in Object.keys(this)) {
      if (key !== 'rootStore' && typeof this[key] !== 'function') {
        obj[key] = this[key];
      }
    }
    return obj;
  }
}

let store: RootStore | undefined;

export function initializeStore(initialState = {}) {
  // Always make a new store if running on server
  if (typeof window === 'undefined') {
    return new RootStore(initialState);
  }

  // Create store once in client
  if (!store) {
    store = new RootStore(initialState);
  }
  return store;
}

export default initializeStore();
